export type Primitive = string | number | bigint | boolean | undefined | symbol | null;

const primitiveTypes = new Set<Primitive>(['string', 'number', 'bigint', 'boolean', 'undefined', 'symbol', 'null']);

export function isPrimitive(value: unknown): value is Primitive {
    // https://developer.mozilla.org/en-US/docs/Glossary/Null
    // JavaScript considers null a primitive, however, due to historical language design mistakes, typeof null === "object"...
    if (value === null) {
        return true;
    }
    return primitiveTypes.has(typeof value);
}
